<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/faqs" active>FAQS</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card" id="cardFaqs">
            <div class="card-body">
                <h6 class="sub-title" style="margin-bottom: 30px;"><span>FAQS</span></h6>
                <ol class="questionsFaqs">
                    <li v-for="(item, index) in listQuestions" :value="index" :key="index" :ref="'content_'+index">
                        <div>
                            <h4 v-b-toggle="'collapse-' + index" @click="ToggleQuestion(index)">{{item.questions}}</h4>
                            <b-collapse :id="'collapse-' + index" class="mt-2">
                                <b-card>
                                    <p v-if="(item.answers!=null && item.answers!='')" >{{item.answers}}
                                        <br v-if="(item.urlVideo!=null && item.urlVideo!='')">
                                        <b-link v-if="(item.urlVideo!=null && item.urlVideo!='')" :href="item.urlVideo"  target="_blank" style="color:royalblue;word-break: break-all;text-decoration: underline;padding-left: 0px;" >
                                            {{item.urlVideo}}
                                        </b-link>
                                    </p>
                                    <p v-if="(item.answers== null && item.urlVideo!='')" > 
                                        <b-link v-if="(item.urlVideo!=null && item.urlVideo!='')" :href="item.urlVideo"  target="_blank" style="color:royalblue;word-break: break-all;text-decoration: underline;padding-left: 0px;" >
                                            {{item.urlVideo}}
                                        </b-link>
                                    </p>
                                </b-card>
                            </b-collapse>
                        </div>
                    </li>
                </ol>
                <div class="seeMore" v-if="(pageSize * pageNumber) < totalRows" @click="SeeMore">
                    See more
                    <img src="@/assets/icons/icon-arrow-bottom.svg" class="svg">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as tools from '@/assets/js/tools.js';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';

export default {
    data(){
        return{
            pageNumber: 1,
            pageSize: 3,
            totalRows: 0,
            listQuestions: []
        }
    },
    mounted(){
        this.GetQuestions();
        this.$nextTick(function () {
			tools.imgToSvg()
		})
    },
    methods: {
        GetQuestions(){
            let params = {
                flagTypeStudent: false,
                Page: this.pageNumber,
                size: this.pageSize
            };

            baseInstanceAxios
                .get(`${this.apiURL}/resources/Faqs/ListFrequentQuestions`, {params})
                .then(resp => {
                    resp.data.list.forEach(element => {
                        this.listQuestions.push(element);
                    });

                    this.totalRows = resp.data.rows;
                });
        },
        SeeMore(){
            this.pageNumber++;
            this.GetQuestions();
        },
        ToggleQuestion(order){
            if(this.$refs[`content_${order}`][0].classList.contains('active')){
                this.$refs[`content_${order}`][0].classList.remove('active');
            }else{
                this.$refs[`content_${order}`][0].classList.add('active');
            }
        }
    }
}
</script>